import React from 'react'

export const Collapse = ({ children, className }) => (
  <div className={`collapse ${className}`}>
    { children }
  </div>
)